module.exports = __webpack_public_path__ + "static/media/filterFunelhover.29e5289d.png";